import { useEffect, useState } from 'react';
import { AnimatedTypography } from './styled';
const FADE_DURATION = 400;
const VISIBLE_TIMER = 3000;
export function LoadingText(props) {
    const { texts, fontSize, fontWeight } = props;
    const [textIndex, setTextIndex] = useState(0);
    const [visible, setVisible] = useState(true);
    useEffect(() => {
        if (texts.length <= 1) {
            return undefined;
        }
        const interval = setInterval(() => {
            setVisible(false);
            setTimeout(() => {
                setTextIndex((i) => (i + 1) % texts.length);
                setVisible(true);
            }, FADE_DURATION);
        }, VISIBLE_TIMER);
        return () => {
            clearInterval(interval);
        };
    }, [texts.length]);
    const text = texts[textIndex];
    return (<AnimatedTypography $visible={visible} $transitionDuration={FADE_DURATION} $fontSize={fontSize} $fontWeight={fontWeight}>
      {text}
    </AnimatedTypography>);
}
